export const courseLearningData = {
  "master-post-laurea-con-stage": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Quattro giornate di impegno settimanale, dalle 9.15 alle 17.15, dal lunedì al giovedì. Potrai scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV), senza obbligo di presenza fisica."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con laboratori, project work ed esercitazioni quotidiane. Grazie alla nostra piattaforma e-learning ti garantiamo un altissimo livello di interazione con docenti e colleghi, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Corsi propedeutici on-demand inclusi nel prezzo, per fornirti le basi necessarie ad affrontare con la giusta preparazione i moduli di studio."
            }
          ]
        },
        "live streaming/roma": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A ROMA O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Quattro giornate di impegno settimanale, dalle 9.15 alle 17.15, dal lunedì al giovedì. Potrai scegliere se seguire le lezioni in aula, nella sede di Roma in via Gaeta 15, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV), senza obbligo di presenza fisica."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con laboratori, project work ed esercitazioni quotidiane. Grazie alla nostra piattaforma e-learning ti garantiamo un altissimo livello di interazione con docenti e colleghi, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Corsi Propedeutici",
              "text": "Corsi propedeutici on-demand inclusi nel prezzo, per fornirti le basi necessarie ad affrontare con la giusta preparazione i moduli di studio."
            }
          ]
        },
      }
    }
  ],
  "professional-master": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Formula 100% in live streaming",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "live streaming + on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Lezioni in live streaming",
              "text": "Sessioni d'aula in live streaming, conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Corsi on demand",
              "text": "Corsi in self learning frequentabili in qualsiasi momento, 24 ore su 24, 7 giorni su 7, dal device che preferisci (computer, smartphone, tablet e smart TV). Corsi registrati e sempre disponibili  per rivederli in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con case study e testimonianze live. Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            }
          ]
        },
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV). Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "live streaming/roma": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A ROMA O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi scegliere se seguire le lezioni in aula, nella sede di Roma in Via Gaeta 15, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV).	Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA, QUANDO VUOI",
          "details": [
            {
              "title": "Formula 100% on demand",
              "text": "Corsi in self learning frequentabili in qualsiasi momento, 24 ore su 24, 7 giorni su 7, dal device che preferisci (computer, smartphone, tablet e smart TV). Le lezioni sono registrate e sempre disponibili  per rivederle in qualsiasi momento."
            },
            {
              "title": "Metodologia didattica",
              "text": "Corsi dal taglio pratico con esercitazioni, case study e testimonianze per mettersi subito alla prova e verificare quanto appreso. Grazie ai test di apprendimento potrai individuare gli argomenti da riprendere o rivedere per una piena comprensione delle materie studiate."
            },
          ]
        },
      }
    },
    {
      "certificateReleaseEntity": [
        "UniMarconi - prodotto BS24",
        "UniMarconi - prodotto UniMarconi",
        "Unitelma"
      ],
      "lessionsMode": {
        "live streaming + on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Formula live streaming + on demand",
              "text": "Un impegno complessivo di 12 mesi, con 1 lezione al mese in live streaming e il resto del percorso in formula on demand, sempre da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV). Le lezioni live saranno registrate e sempre disponibili on demand per rivederle anche al di fuori degli orari di lezione."
            },
            {
              "title": "Interazione",
              "text": "Grazie alle sessioni in live streaming potrai confrontarti con docenti e colleghi."
            },
            {
              "title": "Tesina finale",
              "text": "Richiesta la presentazione di una tesina finale concordata con un docente del master."
            }
          ]
        }
      }
    }
  ],
  "executive-master": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Formula 100% in live streaming",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "live streaming + on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Lezioni in live streaming",
              "text": "Sessioni d'aula in live streaming, conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Corsi on demand",
              "text": "Corsi in self learning frequentabili in qualsiasi momento, 24 ore su 24, 7 giorni su 7, dal device che preferisci (computer, smartphone, tablet e smart TV). Corsi registrati e sempre disponibili  per rivederli in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con case study e testimonianze live. Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            }
          ]
        },
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV). Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "live streaming/roma": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A ROMA O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi scegliere se seguire le lezioni in aula, nella sede di Roma in Via Gaeta 15, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV).	Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "always on": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI IN QUALSIASI MOMENTO",
          "details": [
            {
              "title": "Lezioni in live streaming",
              "text": "Sessioni d'aula in live streaming, conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Corsi on demand",
              "text": "Corsi in self learning frequentabili in qualsiasi momento, 24 ore su 24, 7 giorni su 7, dal device che preferisci (computer, smartphone, tablet e smart TV). Corsi registrati e sempre disponibili per rivederli in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con case study e testimonianze live. Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            }
          ]
        },
      }
    }
  ],
  "corsi-executive": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Formula 100% in live streaming",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
        "live streaming + on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Lezioni in live streaming",
              "text": "Sessioni d'aula in live streaming, conciliabili con l'attività lavorativa: puoi seguire le lezioni da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e compagni. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Corsi on demand",
              "text": "Corsi in self learning frequentabili in qualsiasi momento, 24 ore su 24, 7 giorni su 7, dal device che preferisci (computer, smartphone, tablet e smart TV). Corsi registrati e sempre disponibili  per rivederli in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Didattica interattiva con case study e testimonianze live. Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            }
          ]
        },
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Corsi erogati in formule conciliabili con l'attività lavorativa: puoi scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV). Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Interazione",
              "text": "Grazie alla nostra piattaforma e learning garantiamo un altissimo livello di interazione con docenti e compagni, anche durante le simulazioni, i project work e le esercitazioni su casi reali."
            },
            {
              "title": "Faculty e metodologia didattica",
              "text": "Lezioni a cura di Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented. Didattica interattiva con case study e testimonianze live."
            }
          ]
        },
      }
    }
  ],
  "executive-mba": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Master in formula long week end, conciliabile con l'attività lavorativa. Puoi scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV).  Le nostre aule tecnologicamente avanzate e la piattaforma e-learning permettono la diretta interattiva in Live streaming, per partecipare da ovunque. Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Metodologia didattica",
              "text": "Didattica esperienzale ed interattiva con manager, docenti e colleghi di master attraverso laboratori, project work, esercitazioni su casi reali, company visit, business game, CEO Inspirational Talks ed Head Hunter Talks."
            },
            {
              "title": "Corsi online Propedeutici",
              "text": "Corsi propedeutici in autoformazione, per studiare quando e dove vuoi i contenuti necessari prima delle docenze in aula."
            },
            {
              "title": "Faculty e Partnership",
              "text": "Lezioni a cura di docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented grazie al network d'eccellenza dei Partner del Master."
            },
          ]
        },
      }
    }
  ],
  "mba-full-time": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Master in formula immersiva: quattro giornate di impegno settimanale, dalle 9.15 alle 17.15, dal lunedì al giovedì. Potrai scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live-streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV). Le nostre aule tecnologicamente avanzate e la piattaforma e-learning permettono la diretta interattiva in Live streaming, per partecipare da ovunque."
            },
            {
              "title": "Metodologia didattica",
              "text": "Didattica esperienzale ed interattiva con con manager, docenti e colleghi di master grazie a laboratori, project work, esercitazioni su casi reali, company visit, business game, CEO Inspirational Talks ed Head Hunter Talks. Le nostre aule tecnologicamente avanzate e la piattaforma e-learning permettono la diretta interattiva in Live streaming, per partecipare da ovunque."
            },
            {
              "title": "Corsi online Propedeutici",
              "text": "Corsi propedeutici in autoformazione, per studiare quando e dove vuoi i contenuti necessari prima delle docenze in aula."
            },
            {
              "title": "Faculty e Partnership",
              "text": "Lezioni a cura di docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented grazie al network d'eccellenza dei Partner del Master."
            },
          ]
        },
      }
    }
  ],
  "mba-part-time": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming/milano": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI LIVE A MILANO O A DISTANZA",
          "details": [
            {
              "title": "Formula in aula o in live streaming, a scelta",
              "text": "Master in formula week end e serale, conciliabile con l'attività lavorativa. Puoi scegliere se seguire le lezioni in aula, nella sede di Milano in Via Monte Rosa 91, oppure in live streaming, da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV).  Le nostre aule tecnologicamente avanzate e la piattaforma e-learning permettono la diretta interattiva in Live streaming, per partecipare da ovunque.	Le lezioni saranno registrate e sempre disponibili on demand per rivederle in qualsiasi momento."
            },
            {
              "title": "Metodologia didattica",
              "text": "Didattica esperienzale ed interattiva con con manager, docenti e colleghi di master attraverso laboratori, project work, esercitazioni su casi reali, company visit, business game, CEO Inspirational Talks ed Head Hunter Talks."
            },
            {
              "title": "Corsi online Propedeutici",
              "text": "Corsi propedeutici in autoformazione, per studiare quando e dove vuoi i contenuti necessari prima delle docenze in aula."
            },
            {
              "title": "Faculty e Partnership",
              "text": "Lezioni a cura di docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented grazie al network d'eccellenza dei Partner del Master."
            },
          ]
        },
      }
    }
  ],
  "masterclass": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "live streaming": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "Formula 100% in live streaming",
              "text": "Appuntamenti brevi di 2/3 ore, conciliabili con l'attività lavorativa: puoi seguire le Masterclass da dove vuoi e dal device che preferisci (computer, smartphone, tablet e smart TV) interagendo con docenti e colleghi."
            },
            {
              "title": "Interazione e Faculty",
              "text": "Didattica altamente interattiva con case study e testimonianze live. Docenti di estrazione aziendale e Top Manager per una formazione 100% business oriented."
            },
            {
              "title": "Registrazioni",
              "text": "Gli incontri in Live Streaming saranno registrati e resi disponibili on-demand per rivederli in qualsiasi momento."
            },
          ]
        },
      }
    }
  ],
  "corsi-online": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "On demand",
              "text": "Videolezioni, esercitazioni e test di valutazione dell'apprendimento, sempre disponibili per 12 mesi dalla data di acquisto."
            },
            {
              "title": "Interazione",
              "text": "Esercizi, approfondimenti, slide e tracce audio delle lezioni da salvare sul tuo dispositivo."
            },
          ]
        },
      }
    }
  ],
  "master-online": [
    {
      "certificateReleaseEntity": [],
      "lessionsMode": {
        "on demand": {
          "title": "Come partecipare",
          "subtitle": "SEGUI LE LEZIONI A DISTANZA",
          "details": [
            {
              "title": "On demand",
              "text": "Videolezioni, esercitazioni e test di valutazione dell'apprendimento, sempre disponibili per 12 mesi dalla data di acquisto."
            },
            {
              "title": "Interazione",
              "text": "Esercizi, approfondimenti, slide e tracce audio delle lezioni da salvare sul tuo dispositivo."
            },
          ]
        },
      }
    }
  ],
}